import { stationValidate } from '../../application/dtos/station_validate'

export class stationEntity {
    constructor({id, name, user, warehouse, slots}){
        this.id = id;
        this.name = name;
        this.user = user;
        this.warehouse = warehouse;
        this.slots = slots;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return stationValidate(this);
    }
}